import { useContext, useEffect } from 'react';

import { NavBlockerContext } from '../contexts/navBlocker.context';

export function useNavBlocker() {
    return useContext(NavBlockerContext);
}

export function useNavBlockerSetter(id: string, isBlocked: boolean) {
    const { setBlocked } = useNavBlocker();

    useEffect(() => {
        setBlocked(id, isBlocked);

        return () => {
            isBlocked && setBlocked(id, false);
        };
    }, [ id, isBlocked ]);
}
